/*
 * Copyright (c) 2020 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import { Translations } from "@aws-amplify/ui-components";

const ja = {
  [Translations.SIGN_IN_HEADER_TEXT]: "情報管理センターシステム　ログイン",
  [Translations.USERNAME_LABEL]: "ユーザー名 *",
  [Translations.PASSWORD_LABEL]: "パスワード *",
  [Translations.FORGOT_PASSWORD_TEXT]: "パスワードをお忘れですか？",
  [Translations.CODE_LABEL]: "検証コード",
  [Translations.CODE_PLACEHOLDER]: "コードを入力",
  [Translations.NEW_PASSWORD_LABEL]: "新しいパスワード",
  [Translations.NEW_PASSWORD_PLACEHOLDER]: "新しいパスワードを入力",
};

export default ja;
